import {z} from '@hono/zod-openapi';

/**
 * Shared query-parameter fragment for the reporting endpoints. Accepts either a single
 * value (`?warehouse=a`) or a repeated one (`?warehouse=a&warehouse=b`) and always yields
 * an array of non-empty identifiers.
 */
export const identifiers = z
  .union([z.string(), z.array(z.string())])
  .transform((value) => (typeof value === 'string' ? [value] : value))
  .pipe(z.array(z.string().min(1).max(128)).max(100))
  .optional();
